import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
const API = `${BACKEND_URL}/api`;

export async function motorStep({ input, state }) {
  const { data } = await axios.post(`${API}/motor/step`, {
    input: input ?? "",
    state: state ?? {},
  });
  return data;
}

export async function motorCommit({ state, choices }) {
  const { data } = await axios.post(`${API}/motor/commit`, {
    state: state ?? {},
    choices: choices ?? [],
  });
  return data;
}

export async function motorSearchJobcards({ query, topK = 8 }) {
  const { data } = await axios.post(`${API}/motor/search-jobcards`, {
    query,
    topK,
  });
  return data;
}

export async function jobcardImages(id) {
  const { data } = await axios.get(`${API}/jobcards/${encodeURIComponent(id)}/images`);
  return data;
}

export async function motorRelatedSuggestions({
  contextoPrompt,
  intencionesActuales,
  excludeJobcardIds,
  topK = 8,
  proyectoIntegral,
}) {
  const { data } = await axios.post(`${API}/motor/related-suggestions`, {
    contextoPrompt: contextoPrompt ?? "",
    intencionesActuales: intencionesActuales ?? [],
    excludeJobcardIds: excludeJobcardIds ?? [],
    topK,
    proyectoIntegral: proyectoIntegral ?? null,
  });
  return data;
}

export async function motorBudgetDetail({ partidas, proyectoIntegral }) {
  const { data } = await axios.post(`${API}/motor/budget-detail`, {
    partidas: partidas ?? [],
    proyectoIntegral: proyectoIntegral ?? null,
  });
  return data;
}

export async function reviewBudgetWithAI({ partidas, description }) {
  const { data } = await axios.post(`${API}/ai/review-budget`, {
    partidas,
    description: description || "",
  });
  return data;
}

export async function healthCheck() {
  const { data } = await axios.get(`${API}/health`);
  return data;
}
